export const orderJobType = {
    "CUT": "Раскрой",
    "EDGE": "Кромление",
    "DRILLING": "Сверление",
    "MILLING": "Фрезерование",
    "PACKAGING": "Упаковка"
}